import { OnboardingStepHeader } from "@/features/onboarding/components/onboarding-step-header";
import { ONBOARDING_FORM_STYLES } from "@/features/onboarding/components/onboarding-form-styles";
import { PushNotificationsForm } from "@/components/Forms/PushNotificationsForm";
import { ProviderOnboardingStep } from "../enums/ProviderOnboardingStep";
import { useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import posthog from "posthog-js";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useProviderUser } from "@/hooks/useProviderUser";
import { getProviderNotificationAudience } from "@/components/PushNotifications/notification-audience";

export default function PushNotificationsOnboarding({
  onComplete,
  onBack,
}: {
  onComplete: () => void;
  onBack?: () => void;
}) {
  const trpc = useTRPC();
  const providerUser = useProviderUser();
  const { mutateAsync: updateOnboardingStep } = useMutation(
    trpc.providerOnboarding.updateProviderOnboardingStep.mutationOptions(),
  );

  const handleNext = async (enabled: boolean) => {
    posthog.capture(
      enabled
        ? "provider_onboarding.push_notifications.opt_in"
        : "provider_onboarding.push_notifications.opt_out",
    );

    await updateOnboardingStep({
      onboardingStepId: ProviderOnboardingStep.PUSH_NOTIFICATIONS,
    });
    onComplete();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {onBack && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onBack}
          className={ONBOARDING_FORM_STYLES.backButton}
        >
          <ArrowLeft className="size-4" aria-hidden="true" />
          Back
        </Button>
      )}
      <OnboardingStepHeader title="Enable Notifications" />
      <PushNotificationsForm
        appearance="onboarding"
        onComplete={handleNext}
        audience={getProviderNotificationAudience(providerUser.jobPostsEnabled)}
      />
    </div>
  );
}
